import { setOffline } from '../slices/uiSlice';
import type { AppStoreLike } from './types';

/** Refleja `navigator.onLine` en `ui.offline` (el evento `online`/`offline` del navegador). Devuelve cómo detenerlo. */
export function startConnectivity(
  store: AppStoreLike,
  win: Pick<Window, 'addEventListener' | 'removeEventListener' | 'navigator'> = window,
): () => void {
  const actualizar = (): void => {
    const sinRed = !win.navigator.onLine;
    if (store.getState().ui.offline !== sinRed) store.dispatch(setOffline(sinRed));
  };
  win.addEventListener('online', actualizar);
  win.addEventListener('offline', actualizar);
  actualizar();
  return () => {
    win.removeEventListener('online', actualizar);
    win.removeEventListener('offline', actualizar);
  };
}
